import React, { FunctionComponent, PropsWithChildren } from 'react'
import { EsidProvider } from './EsidContext'
import { useFederatedUserJourneySink } from './federationSink'
import { UserJourneySink } from './sink'
import { UserJourneyContext } from './UserJourneyContext'
import { UserJourneyReporting } from './UserJourneyReporting'
import { UserJourneyStateSync } from './UserJourneyStateSync'
import { useUserJourney } from './useUserJourney'
import { MobileUserJourneyOwnership } from './MobileUserJourneyOwnership'

export interface UserJourneyProviderProps {
  sink?: UserJourneySink
}

const UserJourneyRuntime: FunctionComponent<PropsWithChildren<UserJourneyProviderProps>> = ({ children, sink }) => {
  const userJourney = useUserJourney()
  const federatedSink = useFederatedUserJourneySink()

  return (
    <EsidProvider>
      <UserJourneyContext.Provider value={userJourney}>
        <UserJourneyStateSync />
        <UserJourneyReporting sink={sink ?? federatedSink} />
        {children}
      </UserJourneyContext.Provider>
    </EsidProvider>
  )
}

export const UserJourneyProvider: FunctionComponent<PropsWithChildren<UserJourneyProviderProps>> = (props) => (
  <MobileUserJourneyOwnership>
    <UserJourneyRuntime {...props} />
  </MobileUserJourneyOwnership>
)
